import { Helmet } from 'react-helmet-async';

const PageSEO = ({ title, description, path, type = 'website' }) => {
  const fullTitle = title.includes('Comal Glass') ? title : `${title} | Comal Glass Company`;
  const canonicalUrl = `https://comalglass.com${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
    </Helmet>
  );
};

export default PageSEO;
